import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const SubtractMinusIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M12.8261 8.33545H2.91016"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
    />
  </svg>
);
